import { postLog } from "api";

const levelVerbose = 0;
const levelDebug = 1;
const levelInformation = 2;
const levelWarning = 3;
const levelError = 4;
const levelFatal = 5;

const toInt = (level) => {
  switch (level) {
    case "VERBOSE": {
      return levelVerbose;
    }
    case "DEBUG": {
      return levelDebug;
    }
    case "INFORMATION": {
      return levelInformation;
    }
    case "WARNING": {
      return levelWarning;
    }
    case "ERROR": {
      return levelError;
    }
    case "FATAL": {
      return levelFatal;
    }
    default:
      return "VERBOSE";
  }
};

const toString = (level) => {
  switch (level) {
    case levelVerbose: {
      return "VERBOSE";
    }
    case levelDebug: {
      return "DEBUG";
    }
    case levelInformation: {
      return "INFORMATION";
    }
    case levelWarning: {
      return "WARNING";
    }
    case levelError: {
      return "ERROR";
    }
    case levelFatal: {
      return "FATAL";
    }
    default:
      return 0;
  }
};

/**
 * Write the log message to console and api.
 *
 * @param {int} level
 * @param {string} msg
 * @param {obj} properties
 *
 * properties = {
 *  userID: 0,
 *  eventID: '',
 * }
 */
const write = (level, msg, properties) => {
  if (level >= toInt(process.env.REACT_APP_LOG_LEVEL)) {
    let formattedMsg = msg;

    if (properties) {
      if (properties.eventID) {
        //   formattedMsg = `<${properties.eventID}> ${msg}`;
        formattedMsg = `${msg}`;
      }
    }

    // To the console.
    console.log(formattedMsg);

    // To the log API.
    properties = { ...properties, application: "detect-clientapp" };
    postLog(toString(level), msg, properties);
  }
};

export const log = {
  verbose: (msg, properties) => {
    write(levelVerbose, msg, properties);
  },
  debug: (msg, properties) => {
    write(levelDebug, msg, properties);
  },
  information: (msg, properties) => {
    write(levelInformation, msg, properties);
  },
  warning: (msg, properties) => {
    write(levelWarning, msg, properties);
  },
  error: (msg, properties) => {
    write(levelError, msg, properties);
  },
  fatal: (msg, properties) => {
    write(levelFatal, msg, properties);
  },
};
